"use client";

import { useEffect } from "react";

export default function TypekitLoader() {
  useEffect(() => {
    if (document.getElementById("typekit-css")) return;
    const link = document.createElement("link");
    link.id = "typekit-css";
    link.rel = "stylesheet";
    link.href = "https://use.typekit.net/xfv6oeo.css";
    document.head.appendChild(link);
  }, []);

  return null;
}
